export enum SettingsAdminAuditLogDataEventObjectsEnum {
  ADMIN_AUDIT_LOG_DOWNLOAD = 'admin_audit_log_download',
  ADMIN_AUDIT_LOG_SELECT = 'admin_audit_log_event',
  ADMIN_AUDIT_LOG_APPLY_FILTER = 'admin_audit_log_apply_filter',
  ADMIN_AUDIT_LOG_CLEAR_FILTER = 'admin_audit_log_clear_filter',
  ADMIN_AUDIT_LOG_REFRESH = 'admin_audit_log_refresh',
}
